import { GET_SYNCHRONIZATIONS_FAILED, GET_SYNCHRONIZATIONS_SUCCESS, GET_SYNCHRONIZATIONS_WATCHER } from "./constants";


export function  getSynchronizationsWatcher(payload) {
    return {
        type: GET_SYNCHRONIZATIONS_WATCHER,
        payload,
    }
}

export function getSynchronizationsSuccess(payload) {
    return {
        type: GET_SYNCHRONIZATIONS_SUCCESS,
        payload,
    }
}

export function getSynchronizationsFailed(payload) {
    return {
        type: GET_SYNCHRONIZATIONS_FAILED,
        payload,
    }
}